<template>
  <div class="technical-restriction">
    <header class="technical-restriction-header">
      <img :src="BASE_URL + '/img/logo_row_text.svg'" class="technical-restriction__logo" alt="logotype" />
    </header>

    <div class="technical-restriction-body">
      <slot />
    </div>

    <footer class="technical-restriction-footer">
      <p class="technical-restriction__rights">{{ footerText }}</p>
      <p class="technical-restriction__version">version {{ appVersion }}</p>
    </footer>
  </div>
</template>

<script setup>
import { BASE_URL } from 'src/common/config'
import { computed } from 'vue'
import { useMainStore } from 'stores/main'
import { useI18n } from 'vue-i18n'
import { useSiteInfoStore } from 'stores/site-info'
import { useSystemStore } from 'stores/system'

const { t } = useI18n()
const mainStore = useMainStore()
const systemStore = useSystemStore()
const siteInfoStore = useSiteInfoStore()

const getAppConfig = mainStore.getAppConfig
const isWebView = siteInfoStore.isWebView

const getRelease = computed(() => systemStore.release)
const footerText = computed(() => `© ${new Date().getFullYear()} ${getAppConfig.titlePure}. ${t('all_right')}`)
const appVersion = computed(() => (isWebView ? localStorage.getItem('appVersion') : getRelease.value))
</script>

<style scoped lang="scss">
.technical-restriction {
  display: flex;
  flex-direction: column;
  height: 100vh;
  @supports (height: 100dvh) {
    height: 100dvh;
  }
}

.technical-restriction-header {
  padding: 24px 12px;
  flex-shrink: 0;
  line-height: normal;
  display: flex;
  justify-content: center;
}

.technical-restriction-footer {
  text-align: center;
  padding: 40px 12px 24px 12px;
  margin-top: 24px;
  flex-shrink: 0;
}

.technical-restriction__logo {
  height: 28px;
}

.technical-restriction__rights {
  color: var(--gray-night-500, rgba(255, 255, 255, 0.47));
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.technical-restriction__version {
  color: var(--gray-night-300, rgba(255, 255, 255, 0.28));
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-top: 12px;
}

.technical-restriction-body {
  padding: 24px 0;
  margin: 0 12px;
  flex: 1 1;
  border-top: 1px solid var(--gray-night-200, rgba(255, 255, 255, 0.14));
  border-bottom: 1px solid var(--gray-night-200, rgba(255, 255, 255, 0.14));
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    padding: 64px 0;
    margin: 0 16px;
  }
}
</style>
